import React, { useEffect, useState } from "react";
import { Route, Switch, useRouteMatch, useHistory } from "util/router.js";
import { useDispatch, useSelector } from 'react-redux';
import Nav from 'react-bootstrap/Nav';
import AccountButton from 'components/AccountButton'
import Spinner from 'react-bootstrap/Spinner'
import ComingSoon from 'components/ComingSoon';
import BookingsSection from 'components/BookingsSection'
import PurchasesSection from 'components/PurchasesSection';
import { fetchInstructorData } from 'store/actions/widgetActions';
import PoweredBy from 'components/PoweredBy';
import Image from 'react-bootstrap/Image';
import ClassWidget from "./classWidget";
import ClassWidgetNav from 'components/ClassWidgetNav'
import PartnerWidgetNav from 'components/WidgetNav'
import PartnerWidget from 'components/PartnerWidget'
import OnDemandWidget from 'components/OnDemandWidget'
import ChallengeWidget from 'components/Widgets/challengeWidget'
import {loadReservations, resetUser} from 'store/actions/userActions'
import {useAuth} from 'util/auth'
import { loadAuthorizedApplication } from "store/actions/applicationActions";
import UserInformationPage from 'pages/userInformation'
import {identifyPixel} from 'util/pixel'
import {ProvideWidget, useWidget} from 'util/widget'
import ChallengesPage from 'components/Widgets/challenges'
import './classWidget.scss'
var HtmlToReactParser = require('html-to-react').Parser;
var htmlToReactParser = new HtmlToReactParser(); 

const config = {
    STRIPE_PUBLIC_KEY: process.env.REACT_APP_STRIPE_PUBLIC_KEY
}

function urlify(text) {
    var urlRegex = /(https?:\/\/[^\s]+)/g;
    return text.replace(urlRegex, function(url) {
      return '<a className="primaryColor" target="_blank" href="' + url + '">' + url + '</a>';
    })
    // or alternatively
    // return text.replace(urlRegex, '<a href="$1">$1</a>')
}

function ExpandableBio({bio}) {
    const [expanded, setExpanded] = React.useState(false)

    if (!bio) {
        return null
    }

    const isLong = bio.length > 120

    const htmShortlBio = htmlToReactParser.parse(urlify(bio.substring(0,119) ?? ""))
    const htmlBio = htmlToReactParser.parse(urlify(bio ?? ""))

    

    return (<div className="mb-3">        
        {isLong && !expanded ? (
            <p style={{fontSize: "15px"}}>{htmShortlBio}...<button style={{marginTop: "-2px"}} className="p-0 btn btn-link primaryColor" onClick={() => setExpanded(true)}>Read more</button></p>
        ) : (
            <p style={{whiteSpace: "pre-line", fontSize: "15px"}}>{htmlBio}</p>
        )}
    </div>)
}

export function PartnerAboutSection({show, imageUrl, about, className}) {
    if (!show) {
        return null
    }
    // if (!about) {
    //     return null
    // }
    return (
    <>
        <div className="d-flex flex-column align-items-center">
            <div className="mb-2 mt-5" style={{height: '150px', width: '150px'}}>
                <Image src={imageUrl} roundedCircle style={{objectFit: 'cover', objectPosition: 'center', width: '100%', height: '100%'}} />
            </div>
        </div>
        <div className={"mx-auto text-center " + className}>
            <ExpandableBio 
            bio={about}
            />
        </div>
    </>
    )
}

function WidgetNav(props) {

    const {showBack} = props

    const history = useHistory()

    const isLoading = useSelector(state => state.widget.isLoading)

    return (
        <div className={"navbar mb-1 px-0 pt-3 justify-content-between" + (isLoading ? " invisible" : "")}>

            {showBack ? (

                <Nav.Link
                // href={match.url}
                onClick={() => history.goBack()}
                className="primaryColor pl-0"
                >
                    <i className="fas fa-angle-left mr-2"></i>
                    BACK
                </Nav.Link>
            ) : (<div></div>)}
            <AccountButton
            widget={props.match.params.username}
                />
        </div>
    )
}

function WidgetComponent(props) {

    const widgetName = props.match.params.username;
    const match = props.match

    const widget = useWidget()
    useEffect(() => {
        // console.log("useWidget: ", widget)
        if (widget && widgetName) {
            widget.setWidget(widgetName)
        }
    }, [widget, widgetName])

    const {fullwidth} = props

    const dispatch = useDispatch();
    useEffect(() => {
        if (widget && widget.widgetName) {
            dispatch(fetchInstructorData(widget.widgetName, "user"));
        }
    }, [dispatch, widget]);

    // userData
    // const loggedInUser = useSelector(state => state.user.userData)
    const auth = useAuth()
    useEffect(() => {
        if (!auth.userData) {
            dispatch(resetUser())
            return
        }
        dispatch(loadReservations(auth.userData));
    }, [auth.userData, dispatch]);
    useEffect(() => {
        if (!auth.user) {
            return
        }
        dispatch(loadAuthorizedApplication(auth.user))
    }, [auth.user, dispatch]);

    const isLoading = useSelector(state => state.widget.isLoading)
    const userReady = useSelector(state => !!(state.widget.instructor?.widgetName));
    const imageUrl = useSelector(state => state.widget.instructor.instructorProfile?.partnerImageUrl ?? state.widget.instructor.profileImageUrl);
    const partnerAbout = useSelector(state => state.widget.instructor.instructorProfile?.aboutMe?.story);
    const primaryColor = useSelector(state => state.widget.instructor.instructorProfile?.primaryColor);
    const backgroundColor = useSelector(state => state.widget.instructor.instructorProfile?.backgroundColor);
    const textColor = useSelector(state => state.widget.instructor.instructorProfile?.textColor);
    const partnerPixelId = useSelector(state => state.widget.instructor.instructorProfile?.facebookPixelId);

    useEffect(() => {
        // if (!auth.userData) {
        //     return
        // }
        identifyPixel(partnerPixelId, auth?.userData?.email)
    }, [auth.userData, partnerPixelId]);


    document.documentElement.style.setProperty('--primary-color', primaryColor ?? '#4289FF');
    document.documentElement.style.setProperty('--instructor-background-color', backgroundColor ?? '#ffffff');
    document.documentElement.style.setProperty('--instructor-text-color', textColor ?? '#343a40');

    const stripeAccountId = useSelector(state => state.widget.stripeAccount)
    const [stripe, setStripe] = React.useState(null)
    useEffect(() => {
        if (window.Stripe) {
            if (stripeAccountId) {
                setStripe(window.Stripe(config.STRIPE_PUBLIC_KEY, {
                    stripeAccount: stripeAccountId
                }))
            } else {
                // setStripe(window.Stripe(config.STRIPE_PUBLIC_KEY))
                // DO NOTHING
            }
            
        } else {
            document.querySelector('#stripe-js').addEventListener('load', () => {
              // Create Stripe instance once Stripe.js loads
                if (stripeAccountId) {
                    setStripe(window.Stripe(config.STRIPE_PUBLIC_KEY, {
                        stripeAccount: stripeAccountId
                    }))
                } else {
                    // setStripe(window.Stripe(config.STRIPE_PUBLIC_KEY))
                    // DO NOTHING
                }
            });
        }
    }, [stripeAccountId])

    const showBack = () => {
        var show = false
        
        if (props.location.pathname.includes("my-bookings") ||
        props.location.pathname.includes("my-purchases") ||
        props.location.pathname.includes("my-profile") ||
        props.location.pathname.includes("checkout")) {
            show = true
        }

        return show
    }

    const showAbout = () => {
        const dontshowabout = (
        props.location.pathname.includes("my-bookings") ||
        props.location.pathname.includes("my-purchases") ||
        props.location.pathname.includes("my-profile") ||
        props.location.pathname.includes("checkout") ||
        props.location.pathname.includes("confirm") || 
        props.location.pathname.includes("gifting") || 
        props.location.pathname.includes("write-review") || 
        props.location.pathname.includes("iframe"))
        return !dontshowabout
    }

    const classWidgetIndex = () => {
        if (props.location.pathname.includes("checkout")) {
            return 1
        } else if (props.location.pathname.includes("confirm")) {
            return 2
        }
        return 0
    }

    const partnerWidgetIndex = () => {
        if (props.location.pathname.includes("pricing")) {
            return 1
        } else if (props.location.pathname.includes("on-demand")) {
            return 2
        }
        return 0
    }

    const showPartnerWidgetNav = () => {
        if (props.location.pathname.includes("iframe")) {
            if (props.location.pathname.includes("confirm")) {
                return true
            } else if (props.location.pathname.includes("pricing")) {
                return false
            } else if (props.location.pathname.includes("on-demand")) {
                return false
            }
        }
        
        if (props.location.pathname.includes("checkout")) {
            return false
        } else if (props.location.pathname.includes("gifting")) {
            return false
        } else if (props.location.pathname.includes("write-review")) {
            return false
        }
        
        return true
    }

    return (<>
    {/* {!userReady ? ( */}
    {false ? (
    <div className="text-center p-5">
        <Spinner
        animation="border"
        size="lg"
        role="status"
        aria-hidden={true}
        className="ml-2"
        >
            <span className="sr-only">loading...</span>
        </Spinner>
     </div>

    ) : (
    <div id={fullwidth ? "fullWidthWidget" : "widget"} className="container d-flex flex-column">
        <WidgetNav showBack={showBack()} {...props} />
        <PartnerAboutSection
        show={showAbout()} 
        imageUrl={imageUrl} 
        about={partnerAbout}
        className={"mt-3"}
        />

        <Switch>
            <Route 
            exact
            path={`${match.url}/my-bookings`}
            render={props => {
                return <BookingsSection />
            }}
            />
            <Route 
            exact
            path={`${match.url}/my-profile`}
            render={props => {
                return <UserInformationPage {...props} />
                // return <ComingSoon />
            }} 
            />
            <Route
            exact
            path={`${match.url}/my-purchases`}
            render={props => {
                return <PurchasesSection/>
            }} 
            />
            <Route 
            path={`${match.url}/schedule`}
            render={props => {
                return (<>
                    {userReady ? (
                        <ClassWidgetNav url={`${match.url}/schedule`} selectedIndex={classWidgetIndex()} />
                    ) : (
                        <div className="text-center p-5">
                            <Spinner
                            animation="border"
                            size="lg"
                            role="status"
                            aria-hidden={true}
                            className="ml-2"
                            >
                                <span className="sr-only">loading...</span>
                            </Spinner>
                        </div>
                    )}
                    <ClassWidget stripe={stripe} {...props}/>
                </>)
            }}
            />
            <Route 
            path={`${match.url}/series/:challengeId`}
            render={props => {
                return (<>
                    {/* <ClassWidgetNav url={`${match.url}/schedule`} selectedIndex={classWidgetIndex()} /> */}
                    <ChallengeWidget stripe={stripe} {...props}/>
                </>)
            }}
            />  
            <Route 
            path={`${match.url}/series`}
            render={props => {
                return (<>
                    <ChallengesPage stripe={stripe} {...props}/>
                </>)
            }}
            />  
            <Route 
            path={`${match.url}/videos`}
            render={props => {
                return (<>
                    {/* <ClassWidgetNav url={`${match.url}/schedule`} selectedIndex={classWidgetIndex()} /> */}
                    {/* <ClassWidget stripe={stripe} {...props}/> */}
                    <OnDemandWidget stripe={stripe} {...props} />
                </>)
            }}
            /> 
            <Route 
            path={`${match.url}`}
            // component={ClassWidget}
            render={props => {
                return (<>
                    {userReady ? (
                        <PartnerWidgetNav show={showPartnerWidgetNav()} url={`${match.url}`} selectedIndex={partnerWidgetIndex()} />
                    ) : (
                        <div className="text-center p-5">
                            {/* <Spinner
                            animation="border"
                            size="lg"
                            role="status"
                            aria-hidden={true}
                            className="ml-2"
                            >
                                <span className="sr-only">loading...</span>
                            </Spinner> */}
                        </div>
                    )}
                    <PartnerWidget stripe={stripe} {...props} />
                    {/* <ClassWidgetNav url={`${match.url}`} selectedIndex={classWidgetIndex()} />
                    <ClassWidget stripe={stripe} {...props}/> */}
                </>)
            }}
            /> 
        
        </Switch>

        <PoweredBy hidden={isLoading || props.location.pathname.includes("confirm")} />
    </div>
    )}
    </>)
}

function Widgets(props) {

    return (
        <ProvideWidget>
            <WidgetComponent {...props}></WidgetComponent>
        </ProvideWidget>
    )
}

export default Widgets;